export const MENU_THEME = {
  lactose_gluten: { glow: "#2F86C8", motif: "silk", motifName: "Silk ripples" },
  low_histamine: { glow: "#0E9AAE", motif: "rings", motifName: "Cellular rings" },
  nut_free: { glow: "#3A9E7E", motif: "hex", motifName: "Shield lattice" },
  low_sulphur: { glow: "#0F8F86", motif: "tide", motifName: "Tide lines" },
  fodmap: { glow: "#17736B", motif: "contour", motifName: "Botanical contours" },
  vegan: { glow: "#1E8A4C", motif: "veins", motifName: "Leaf veins" },
  ibs_friendly: { glow: "#2563A8", motif: "harmonic", motifName: "Harmonic waves" },
  catechol_free: { glow: "#1D4E79", motif: "moon", motifName: "Moon currents" },
  broths: { glow: "#2E6E58", motif: "spiral", motifName: "Thermal spiral" },
};

export const DEFAULT_GLOW = "#0B7682";
export const themeFor = (key) => MENU_THEME[key] || { glow: DEFAULT_GLOW, motif: "contour" };
export const dishTheme = (dish) => themeFor(dish.course === "broth" ? "broths" : dish.menus?.[0]);

export const hexToRgba = (hex, a) => {
  const n = parseInt(hex.slice(1), 16);
  return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, ${a})`;
};
